export const SPACE = ' '

export function hasText(str: string | null | undefined) {
  return str !== undefined && str !== null && str.trim().length > 0
}

export function excludeDeleted(item: Partial<{ deleted?: boolean }>) {
  return !item.deleted
}

export function sortBySequenceNumber(a: { sequenceNumber: number | null }, b: { sequenceNumber: number | null }) {
  // eslint-disable-next-line max-len, no-nested-ternary
  return a.sequenceNumber !== null && b.sequenceNumber !== null ? (a.sequenceNumber < b.sequenceNumber) ? -1 : ((a.sequenceNumber > b.sequenceNumber) ? 1 : 0) : 0
}

export function isDeletedWithId(item: Partial<{ id: number | null; deleted?: boolean }>) {
  return item.deleted === true && item.id !== null
}

export function parseNumber(num: number | null | undefined) {
  if (num === null) return null
  if (num === undefined) return undefined

  return Number.isNaN(num) ? null : Number(num)
}
export function parseStringToNumber(num: string | null | undefined) {
  if (num === null) return null
  if (num === undefined) return undefined

  return parseNumber(Number(num))
}

export function concatStreetAndNumber(street: string, streetNumber: string | null | undefined): string {
  let result = street
  if (hasText(streetNumber)) {
    result = street + SPACE + streetNumber
  }
  return result
}

export function adjustToHumanReadableField(field: string) {
  if (!(field.includes('[') && field.includes(']'))) {
    return field
  }

  const matches = field.matchAll(/\[.]/g)
  let isDone: undefined | boolean = false
  let fieldPathWithArray = `${field}`

  while (!isDone) {
    const nextItem: IteratorResult<RegExpMatchArray, RegExpMatchArray> = matches.next()
    isDone = nextItem.done
    if (isDone) {
      break
    }

    const arrayIndexAccessor = nextItem.value['0']
    const propertyAccessorWithoutBrackets = arrayIndexAccessor?.substring(1, arrayIndexAccessor.length - 1) ?? '0'
    const oneBasedAccessor = Number(propertyAccessorWithoutBrackets) + 1

    let precedingField = ''
    const matchIndex = nextItem.value.index ?? 0
    if (matchIndex > 0) {
      precedingField = fieldPathWithArray.substring(0, matchIndex - 1)
    }

    const remainingField = fieldPathWithArray.substring(matchIndex + arrayIndexAccessor.length)
    fieldPathWithArray = `${precedingField}[${oneBasedAccessor}]${remainingField}`
  }
  return fieldPathWithArray
}

export function replaceListSquareBracketsWithDotDelimiter(path: string) {
  return path.replace('[', '.')
    .replace('].', '.')
}

export const roundToNctsScale = (n: number) => Math.round(n * 1e3) / 1e3
